import { IJapaneseWriting } from '../interface/i-japanese-writing';

export class JapaneseWritingFactory {
  static new(props: IJapaneseWriting): IJapaneseWriting {
    return { ...props };
  }
}
